import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_1, SPACING_2, SPACING_3 } from 'constants/theme-constants';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${cxTheme.spacing[SPACING_2]};
  `}
`;
export const TooltipColorBar = styled.div<{ $color: string }>`
  ${({ theme, $color }) => `
    width: ${cxTheme.spacing[SPACING_1]};
    height: 72px;
    background-color: ${$color};
    border-radius: 2px;
  `}
`;
export const TooltipItemText = styled.div`
  ${({ theme }) => `
    ${theme.label.medium.normal};
    color: ${theme.text.onSurface.strong};
  `}
`;
export const TooltipItem = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: ${cxTheme.spacing[SPACING_3]};
  `}
`;
